import script from "./Lastname.vue?vue&type=script&setup=true&lang=js"
export * from "./Lastname.vue?vue&type=script&setup=true&lang=js"

import "./Lastname.vue?vue&type=style&index=0&id=5be2ac1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be2ac1a"]])

export default __exports__